import { tns } from 'tiny-slider';
var ProductSlider = /** @class */ (function () {
    function ProductSlider(element) {
        this.postSliderBlock = element;
        this.blockID = this.postSliderBlock.id;
        this.sliderContainer = element.querySelector('.slider-content');
        if (this.sliderContainer.childElementCount > 0) {
            // Check if slider contains any elements - initiate slider
            this.initSlider();
        }
        this.addEventListeners();
    }
    ProductSlider.prototype.addEventListeners = function () {
        var _this = this;
        // wait for page to load
        window.addEventListener('load', function () {
            // if url hash contains blockID scroll to block
            var hash = window.location.hash;
            if (hash && hash.includes(_this.blockID)) {
                _this.postSliderBlock.scrollIntoView({ behavior: 'smooth' });
            }
        });
    };
    ProductSlider.prototype.initSlider = function () {
        var slider = tns({
            container: this.sliderContainer,
            items: 2,
            slideBy: 1,
            gutter: 12,
            loop: false,
            autoplay: false,
            controls: false,
            nav: true,
            navPosition: 'bottom',
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            //@ts-ignore
            prevButton: this.postSliderBlock.querySelector('.previous-slide-toggle'),
            //@ts-ignore
            nextButton: this.postSliderBlock.querySelector('.next-slide-toggle'),
            responsive: {
                770: {
                    items: 3,
                    gutter: 24,
                    controls: false,
                    nav: true,
                },
                964: {
                    items: 4,
                    gutter: 32,
                    controls: true,
                    nav: true,
                }
            },
        });
    };
    return ProductSlider;
}());
export default ProductSlider;
var productSliderBlocks = document.querySelectorAll('[data-product-slider-alt-block]');
productSliderBlocks.forEach(function (sliderBlock) {
    new ProductSlider(sliderBlock);
});
